<template>
    <LoaderCircular v-if="isLoading" class="loader-circular" />
    <SettingsBlock v-else title="Company settings">
        <div v-if="isEvaluation" class="settings">
            <Checkbox v-model="companySettings.moodMonitorEnabled" label="Enable Mood monitor" />
        </div>
        <div class="settings">
            <Checkbox
                v-model="companySettings.integrationApiKeyEnabled"
                label="Enable integration API key"
            />
        </div>
    </SettingsBlock>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import SettingsBlock from "@/components/layout/SettingsBlock.vue";
import { Checkbox, LoaderCircular } from "@feedbackcompany/feedback-company-vue-components";
import deepEqual from "deep-equal";
import cloneDeep from "lodash.clonedeep";
import { ref, computed, watch } from "vue";
import { useStore } from "@/helpers/composition-helper";
import { useMutation } from "@vue/apollo-composable";
import updateCompanySettings from "../graphql/updateCompanySettings.gql";

const store = useStore();

const props = defineProps({
    company: {
        type: Object,
        required: true,
    },
    isLoading: {
        type: Boolean,
        reqired: false,
    },
});

const companySettings = ref(cloneDeep(props.company));
const originalCompanySettings = ref(cloneDeep(props.company));
const emit = defineEmits(["isDirty"]);

const isDirty = computed(() => {
    return !deepEqual(originalCompanySettings.value, companySettings.value);
});
const isEvaluation = computed(() => {
    return props.company.services.includes("EVALUATION");
});

watch(isDirty, () => {
    emit("isDirty", isDirty.value);
});

// mutations
const { mutate, onDone, onError } = useMutation(updateCompanySettings);
onDone((response) => {
    // eslint-disable-next-line no-throw-literal
    if (!response.data.updateCompanySettings) throw false;
    store.dispatch("pushNotification", {
        type: "success",
        title: "Success",
        message: "You've successfully updated Company settings",
    });
    // emit loadCompany once sync issue is fixed on BE, until then just set lastest sestting if update is successful
    props.company.moodMonitorEnabled = companySettings.value.moodMonitorEnabled;
    props.company.integrationApiKeyEnabled = companySettings.value.integrationApiKeyEnabled;
    companySettings.value = cloneDeep(props.company);
    originalCompanySettings.value = cloneDeep(props.company);
});
onError(() => {
    store.dispatch("pushNotification", {
        type: "error",
        title: "Error",
        message: "Something went wrong while updating settings.",
    });
});

function save() {
    const variables = {
        companyId: companySettings.value.id,
        moodMonitorEnabled: companySettings.value.moodMonitorEnabled,
        integrationApiKeyEnabled: companySettings.value.integrationApiKeyEnabled,
    };
    mutate(variables);
}

// expose
defineExpose({
    save,
});
</script>

<style lang="scss" scoped>
.settings {
    margin-top: 20px;
}
</style>
